import React from 'react';
import { Redirect } from 'react-router-dom';
import { useArtistContext } from 'components/core/ArtistContext';

export const ProfileRedirect = () => {
  const { profileId } = useArtistContext();
  return <Redirect to={`/profile/${profileId}`} />;
};
